var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33 35.683c-1.882 0-3.408-1.562-3.408-3.488V15.348h34.28v16.847c0 1.926-1.526 3.488-3.409 3.488H6.33zM6.281 2.99h27.512c1.883 0 3.409 1.562 3.409 3.488v5.88H2.922v-5.88c0-1.926 1.526-3.488 3.408-3.488h-.049zM6.331 0C2.833 0 0 2.692 0 6.012v26.546c0 3.32 2.834 6.012 6.33 6.012h27.463c3.496 0 6.33-2.692 6.33-6.012V6.012c0-3.32-2.834-6.012-6.33-6.012H6.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.217 5.774a1.443 1.443 0 1 1 0 2.886 1.443 1.443 0 0 1 0-2.886M14.434 7.217a1.443 1.443 0 1 1-2.887 0 1.443 1.443 0 0 1 2.887 0zM20.31 8.66h12.785c.854 0 1.547-.646 1.547-1.443s-.693-1.443-1.547-1.443H20.311c-.854 0-1.547.646-1.547 1.443s.693 1.443 1.547 1.443"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 21)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#D0021B"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.438 16.438L8.563 8.561M8.562 16.438l7.876-7.875"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteDelete);
export default __webpack_public_path__ + "static/media/website-delete.2ceaabcdbba48d5e4bceb894f3c888f5.svg";
export { ForwardRef as ReactComponent };